import { render, staticRenderFns } from "./CurrentLesson.vue?vue&type=template&id=34350696"
import script from "./CurrentLesson.vue?vue&type=script&lang=js"
export * from "./CurrentLesson.vue?vue&type=script&lang=js"
import style0 from "./CurrentLesson.vue?vue&type=style&index=0&id=34350696&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports